import React from 'react';
import classnames from 'classnames';
import { PageCard } from 'omni-common-ui';
import styles from './style.postcss';
import PropTypes from 'prop-types';

export const HomeworkCard = (props) => {
  const { className } = props;
  const {
    averageScorePercentage,
    completedAssignments,
    totalAssignments,
    completedPaperBased,
    totalPaperBased,
    shouldShowPaperBased,
  } = props;
  return <PageCard className={classnames(className, styles.HomeworkCard)}>
    <PageCard.Heading text="Homework" />
    <PageCard.Content>
      <div className={styles.HomeworkCard_wrapper}>
        <p className={styles.HomeworkCard_subtitle}>
          Assignments completed
        </p>
        <div className={styles.HomeworkCard_dots_wrapper}>
          <span className={styles.HomeworkCard_dots_caption}>
            {`${completedAssignments}/${totalAssignments}`}
          </span>
          {
            totalAssignments <= 10 &&
            <div className={styles.HomeworkCard_dots}>
              {[...Array(completedAssignments).keys()].map((index) =>
                <span key={index}
                    className={classnames(styles.HomeworkCard_dot,
                        styles.HomeworkCard_dot_filled)} />
              )}
              {[...Array(totalAssignments - completedAssignments).keys()].map((index) =>
                <span className={styles.HomeworkCard_dot} key={index} />
              )}
            </div>
          }
        </div>
        <p className={styles.HomeworkCard_subtitle}>
          Average score for completed assignments
        </p>
        <span className={styles.HomeworkCard_avgScorePerc}>
          {averageScorePercentage || 0}%
        </span>
        { shouldShowPaperBased && [
          <p className={styles.HomeworkCard_subtitle}>
            Paper-based practice completed
          </p>,
          <div className={styles.HomeworkCard_dots_wrapper}>
            <span className={styles.HomeworkCard_dots_caption}>
              {`${completedPaperBased}/${totalPaperBased}`}
            </span>
            <div className={styles.HomeworkCard_dots}>
              {[...Array(completedPaperBased).keys()].map((index) =>
                <span key={index}
                    className={classnames(styles.HomeworkCard_dot,
                      styles.HomeworkCard_dot_filled)} />
              )}
              {[...Array(totalPaperBased - completedPaperBased).keys()].map((index) =>
                <span key={index} className={styles.HomeworkCard_dot} />
              )}
            </div>
          </div>,
        ]}
      </div>
    </PageCard.Content>
  </PageCard>;
};

HomeworkCard.propTypes = {
  averageScorePercentage: PropTypes.number,
  completedAssignments: PropTypes.number,
  totalAssignments: PropTypes.number,
  className: PropTypes.string,
  shouldShowPaperBased: PropTypes.bool.isRequired,
  completedPaperBased: PropTypes.number,
  totalPaperBased: PropTypes.number,
};

export default HomeworkCard;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/HomeworkCard/index.jsx